import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import {
  CHAT_SIDE_PANEL_SHELL_CLASS,
  usePanelWidthTransition,
} from '../hooks/usePanelWidthTransition';

export const CHAT_DOCUMENT_PREVIEW_PANEL_WIDTH_CLASS = 'w-[52%]';
export const CHAT_CONVERSATION_DOCUMENTS_PANEL_WIDTH_CLASS = 'w-[min(100%,24rem)]';

type ChatSidePanelShellProps = {
  children: ReactNode;
  isOpen: boolean;
  openWidthClass?: string;
  testId: string;
};

export function ChatSidePanelShell({
  children,
  isOpen,
  openWidthClass = CHAT_DOCUMENT_PREVIEW_PANEL_WIDTH_CLASS,
  testId,
}: ChatSidePanelShellProps) {
  const isWidthExpanded = usePanelWidthTransition(isOpen);

  return (
    <div
      className={cn(CHAT_SIDE_PANEL_SHELL_CLASS, isWidthExpanded ? openWidthClass : 'w-0')}
      data-testid={testId}
    >
      <div className="h-full w-full overflow-hidden">{children}</div>
    </div>
  );
}
